<nav class="sidebar">
  <div class="center-object h-65">
    <img class="logo" [src]="company?.logo || 'assets/images/company/company-logo.png'" alt="">
  </div>
  <div class="side-container">
    <div class="form-check" (click)="scrollWindow('vacancy')">
      <label class="radio"
        [ngStyle]="{'color': position?.key === 'vacancy' ? company?.landingPage?.colors?.mainColor : '' }">
        <input id="openVacancies" name="sidebarSelect" value="accept" type="radio">
        <span>Oportunidades Abertas</span>
      </label>
    </div>
    <div class="form-check" (click)="scrollWindow('about')">
      <label class="radio"
        [ngStyle]="{'color': position?.key === 'about' ? company?.landingPage?.colors?.mainColor : '' }">
        <input id="aboutCompany" name="sidebarSelect" value="accept" type="radio">
        <span>Quem Somos</span>
      </label>
    </div>
    <div class="form-check" (click)="scrollWindow('mission')">
      <label class="radio"
        [ngStyle]="{'color': position?.key === 'mission' ? company?.landingPage?.colors?.mainColor : '' }">
        <input id="missionCompany" name="sidebarSelect" value="accept" type="radio">
        <span>Nossa Missão</span>
      </label>
    </div>
    <div class="form-check" (click)="scrollWindow('process')">
      <label class="radio"
        [ngStyle]="{'color': position?.key === 'process' ? company?.landingPage?.colors?.mainColor : '' }">
        <input id="processCompany" name="sidebarSelect" value="accept" type="radio">
        <span>Processo Seletivo</span>
      </label>
    </div>

    <div *ngIf="quemindica && !userReferal">
      <p [style.color]="company?.landingPage?.colors?.mainColor">{{ company?.landingPage?.indication?.modal?.title || 'Indique um amigo' }}</p>

      <div class="row">
        <a (click)="openDialog()" class="connect-items col-md-12 col-6">
          <img src="assets/images/icons/compartilhar.svg" alt="" title="Indicações">
          <p>Indicações</p>
        </a>
      </div>
    </div>

    <p [style.color]="company?.landingPage?.colors?.mainColor">Conecte-se</p>

    <div class="row">
      <a href="{{ formatUrls(company?.site) }}" target="_blank" class="connect-items col-md-12 col-6">
        <img src="assets/images/social-media/gray-grid-world.svg" alt="">
        <p>Site Oficial</p>
      </a>
      <div class="" *ngIf="company?.landingPage?.config?.showSocialNetworks == true">
        <a href="{{company?.landingPage?.socialNetworks?.twitter}}" target="_blank"
          class="connect-items col-md-12 col-6" *ngIf="company?.landingPage?.socialNetworks?.twitter">
          <img src="assets/images/social-media/gray-twitter.svg" alt="">
          <p>Twitter</p>
        </a>
        <a href="{{company?.landingPage?.socialNetworks?.instagram}}" target="_blank"
          class="connect-items col-md-12 col-6" *ngIf="company?.landingPage?.socialNetworks?.instagram">
          <img src="assets/images/social-media/gray-instagram.svg" alt="">
          <p>Instagram</p>
        </a>
        <a href="{{company?.landingPage?.socialNetworks?.linkedin}}" target="_blank"
          class="connect-items col-md-12 col-6" *ngIf="company?.landingPage?.socialNetworks?.linkedin">
          <img src="assets/images/social-media/gray-linkedin.svg" alt="">
          <p>LinkedIn</p>
        </a>
        <a href="{{company?.landingPage?.socialNetworks?.youtube}}" target="_blank"
          class="connect-items col-md-12 col-6" *ngIf="company?.landingPage?.socialNetworks?.youtube">
          <img src="assets/images/social-media/gray-youtube.svg" alt="">
          <p>Youtube</p>
        </a>
        <a href="{{company?.landingPage?.socialNetworks?.facebook}}" target="_blank"
          class="connect-items col-md-12 col-6" *ngIf="company?.landingPage?.socialNetworks?.facebook">
          <img src="assets/images/social-media/gray-facebook.svg" alt="">
          <p>Facebook</p>
        </a>
      </div>
    </div>
  </div>
</nav>
